<template lang="html">
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">New Step</p>
      </header>

      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <ValidationProvider
              slim
              rules="required"
              name="Title"
              v-slot="{ errors, valid }"
            >
              <b-field
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <template slot="label">
                  Step Title
                  <b-tooltip
                    type="is-dark"
                    multilined
                    size="is-small"
                    position="is-right"
                    label="Add a title for the step."
                  >
                    <b-icon
                      type="is-gray"
                      size="is-small"
                      icon="help-circle-outline"
                    ></b-icon>
                  </b-tooltip>
                </template>
                <b-input
                  maxlength="50"
                  placeholder="e.g. Cut the fabric"
                  v-model="title"
                ></b-input>
              </b-field>
            </ValidationProvider>

            <b-field>
              <template slot="label">
                Step description
                <b-tooltip
                  type="is-dark"
                  multilined
                  size="is-small"
                  position="is-right"
                  label="Add a description on how to perform this step."
                >
                  <b-icon
                    type="is-gray"
                    size="is-small"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-input
                maxlength="1000"
                placeholder="Cut in half the right part..."
                type="textarea"
                v-model="description"
              ></b-input>
            </b-field>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <span class="card-footer-item">
          <b-button @click="$parent.close()"> Close </b-button>
        </span>

        <span class="card-footer-item">
          <b-button
            @click="handleSubmit(createStep)"
            type="is-success"
            icon-pack="mdi"
            icon-right="check"
          >
            Create
          </b-button>
        </span>
      </footer>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { textMixin } from '@/mixins/textMixin'
export default {
  props: ['desiredPosition', 'steppableId', 'steppableType'],
  mixins: [textMixin],
  data () {
    return {
      title: null,
      description: null
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  methods: {
    createStep () {
      let newStep = {
        title: this.title,
        description: this.description,
        steppable_order_position: this.desiredPosition,
        steppable_id: this.steppableId,
        steppable_type: this.textTitleize(this.steppableType)
      }
      this.$store
        .dispatch('steps/create', {
          steppableId: this.steppableId,
          steppableType: this.steppableType,
          payload: newStep
        })
        .then((resp) => {
          this.$emit('stepCreated', resp.data.data)
          this.$parent.close()
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response.data)
        })
    }
  }
}
</script>

<style lang="css" scoped></style>
